<!-- Modern Header Component -->
<header class="modern-header">
  <!-- Background Hero Section -->
  <div class="hero-section" [style.background-image]="'url(assets/photos/banner2.jpg)'">
    <div class="hero-overlay"></div>
    <div class="hero-bg-overlay"></div>
    <!-- Hero Content -->
    <div class="hero-content">
      <div class="container-fluid h-100">
        <div class="row h-100 align-items-center">
          <!-- Title Section -->
          <div class="col-12 col-lg-8">
            <div class="title-section">
              <h1 class="modern-title" [attr.aria-label]="adminService.title">
                {{ adminService.title }}
              </h1>
            </div>
          </div>
          <!-- User Profile Section -->
          <div class="col-12 col-lg-4">
            <div class="user-profile-section">
              <div class="user-profile-card">
                <div class="user-avatar">
                  <img *ngIf="profilePictureUrl" [src]="profilePictureUrl" [alt]="userName + ' profile picture'"
                    class="profile-image" (error)="profilePictureUrl = null">
                  <span *ngIf="!profilePictureUrl" class="user-initials">{{ getUserInitials() }}</span>
                </div>
                <div class="user-info">
                  <span class="username" [attr.aria-label]="'Logged in as ' + userName">
                    <span class="full-name">{{ firstName }} {{ lastName }}
                      <span *ngIf="isAdminUser" class="admin-badge" title="Admin">
                        <i class="fas fa-shield-alt"></i> Admin
                        <a class="admin-nav-icon" [routerLink]="getAdminBadgeRoute()" [title]="getAdminBadgeTitle()"
                          [attr.aria-label]="getAdminBadgeAriaLabel()">
                          <i class="fas" [class.fa-home]="isAdminPage" [class.fa-cog]="!isAdminPage"></i>
                        </a>
                      </span>
                    </span>
                  </span>
                  <button class="logout-btn" (click)="logout()" [attr.aria-label]="'Logout ' + userName" type="button">
                    <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Navigation Section -->
  <nav class="navigation-section" *ngIf="shouldShowTabs" role="navigation" aria-label="Calculator navigation">
    <!-- Mobile Navigation -->
    <div class="mobile-navigation d-lg-none">
      <!-- Mobile menu backdrop -->
      <div class="mobile-menu-backdrop" [class.open]="isMobileMenuOpen" (click)="toggleMobileMenu()"
        [attr.aria-hidden]="!isMobileMenuOpen">
      </div>
      <div class="container-fluid px-3">
        <div class="mobile-nav-wrapper">
          <button class="mobile-nav-toggle" type="button" [attr.aria-expanded]="isMobileMenuOpen"
            aria-controls="mobile-menu" (click)="toggleMobileMenu()"
            [attr.aria-label]="isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'">
            <!-- Active section indicator -->
            <span class="current-section-indicator">
              <i class="fas fa-calculator" aria-hidden="true"></i>
            </span>
            <span class="nav-text">{{ getCurrentActiveTab()?.title || 'Select Calculator' }}</span>
            <span class="nav-arrow">
              <i class="fas fa-chevron-down" [class.rotated]="isMobileMenuOpen" aria-hidden="true"></i>
            </span>
          </button>
          <div class="mobile-menu" id="mobile-menu" [class.open]="isMobileMenuOpen"
            [attr.aria-hidden]="!isMobileMenuOpen">
            <div class="mobile-menu-content">
              <button *ngFor="let item of dropdownItems; trackBy: trackByKey" class="mobile-menu-item"
                [class.active]="isActiveTab(item.key)" (click)="selectCalculator(item.key)"
                [attr.aria-label]="'Switch to ' + item.displayText" type="button">
                <span class="menu-item-text">{{ item.displayText }}</span>
                <i class="fas fa-check" *ngIf="isActiveTab(item.key)" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Desktop Navigation -->
    <div class="desktop-navigation d-none d-lg-block">
      <div class="container-fluid">
        <div class="desktop-nav-wrapper">
          <div class="nav-tabs-container" [class.no-arrows]="!shouldShowScrollArrows">
            <!-- Previous Arrow -->
            <button class="nav-arrow-btn nav-arrow-prev" #prevBtn (click)="scrollTabs('prev')"
              [disabled]="!canScrollPrev" [style.display]="shouldShowScrollArrows ? 'flex' : 'none'"
              aria-label="Previous tabs" type="button">
              <i class="fas fa-chevron-left" aria-hidden="true"></i>
            </button>
            <!-- Tabs Container -->
            <div class="nav-tabs-scroll" #tabsContainer (scroll)="checkScrollState()">
              <div class="nav-tabs" role="tablist">
                <button *ngFor="let tab of getCurrentTabs(); let i = index; trackBy: trackByKey" class="nav-tab"
                  [class.active]="activeTabIndex === i" (click)="selectCalculator(tab.key)"
                  [attr.aria-selected]="activeTabIndex === i" [attr.aria-controls]="'tabpanel-' + tab.key"
                  [attr.id]="'tab-' + tab.key" role="tab" type="button" [attr.aria-label]="'Switch to ' + tab.title">
                  <!-- Active indicator badge -->
                  <span class="active-badge" *ngIf="activeTabIndex === i" aria-hidden="true">
                    <i class="fas fa-circle"></i>
                  </span>
                  <span class="tab-text">{{ tab.title }}</span>
                  <span class="tab-indicator" aria-hidden="true"></span>
                </button>
              </div>
            </div>
            <!-- Next Arrow -->
            <button class="nav-arrow-btn nav-arrow-next" #nextBtn (click)="scrollTabs('next')"
              [disabled]="!canScrollNext" [style.display]="shouldShowScrollArrows ? 'flex' : 'none'"
              aria-label="Next tabs" type="button">
              <i class="fas fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>
